<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">{{ isEditing ? 'Edit' : 'New' }} {{ countryCode }} XML template</h2>
  <p class="dialog-subtitle">
    {{ scope === 'DOCUMENT'
      ? 'The envelope — one per country, holding the {{events}} slot the rendered events are spliced into.'
      : 'The fragment for one EPCIS event type, with {{term}} bound to the trace item and its event.' }}
  </p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Scope</mat-label>
    <mat-select [(ngModel)]="scope" name="scope" [disabled]="isEditing" (selectionChange)="onScopeChange()">
      <mat-option value="DOCUMENT">Document envelope</mat-option>
      <mat-option value="EVENT">Event fragment</mat-option>
    </mat-select>
  </mat-form-field>

  @if (scope === 'EVENT') {
    <mat-form-field appearance="outline">
      <mat-label>Event type (optional)</mat-label>
      <input
        matInput
        [(ngModel)]="eventType"
        name="eventType"
        [disabled]="isEditing"
        placeholder="AggregationEvent"
      />
      <mat-hint>Omit for the wildcard (*) every other type falls back on</mat-hint>
    </mat-form-field>
  }

  <mat-form-field appearance="outline">
    <mat-label>Template</mat-label>
    <textarea
      matInput
      class="template-textarea"
      [(ngModel)]="template"
      name="template"
      rows="12"
      spellcheck="false"
    ></textarea>
    <mat-hint>Double-brace a term to substitute it, and wrap #each/.../\/each around a list to repeat it.</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Description (optional)</mat-label>
    <input matInput [(ngModel)]="description" name="description" placeholder="Malaysia customs declaration" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Saving…' : 'Save' }}
  </button>
</mat-dialog-actions>
